// extracted by mini-css-extract-plugin
export var chip = "_bp-0";
export var filterDropdown = "_bp-5";
export var filterItem = "_bp-6";
export var icon = "_bp-1";
export var removeButton = "_bp-3";
export var removeIcon = "_bp-4";
export var separator = "_bp-2";